import {fetchSlots, getLocalTimezone} from './widget-online';
import {DateTime} from "luxon";

const MAX_USER_SLOTS = 8;

function SecondCalendar (calendarNode) {
    this.calendarNode = calendarNode;
    this.serviceId = parseInt(this.calendarNode.dataset.serviceId);
    this.userId = parseInt(this.calendarNode.dataset.userId);

    this.loadCalendar = () => {
        if (null === this.calendarNode) {
            return;
        }

        this.parseSlots();
    };

    this.parseSlots = () => {
        this.calendarNode.querySelector('.second-calendar-more-profile').classList.add('disabled');
        this.calendarNode.querySelector('.second-calendar-info').classList.add('second-calendar-loading');
        this.calendarNode.querySelector('.loading-ring').style.display = "inline-block";

        fetchSlots(this.userId, this.serviceId, this.processSlots);
    };

    this.processSlots = slots => {
        let localSlots = [];

        let firstDate = null;
        let breakNested = false;

        for (const day in slots) {
            for (const hour in slots[day]) {
                let date = DateTime.fromFormat(
                    `${day} ${hour} Europe/Warsaw`,
                    "yyyy-MM-dd HH:mm z"
                ).setZone(getLocalTimezone());

                const dayInFormat = date.toFormat('y-LL-dd');

                if (null === firstDate) {
                    firstDate = dayInFormat;
                } else if (firstDate !== dayInFormat) {
                    breakNested = true;
                    break;
                }

                localSlots.push(date.toFormat('HH:mm'));
            }

            if (breakNested) {
                break;
            }
        }

        this.parseWidgetData(firstDate, localSlots.slice(0, MAX_USER_SLOTS));
    };

    this.parseWidgetData = (day, slots) => {
        let href = this.calendarNode.querySelector('.user-template').dataset.src;

        let userData = {
            id: this.userId,
            name: this.calendarNode.querySelector('.user-template .user-template-text-title').dataset.userName,
            thumbnail: this.calendarNode.querySelector('.user-template .user-template-image img').getAttribute('src'),
            price: this.calendarNode.querySelector('.second-calendar-card').dataset.userPrice,
            slug: href.substring(href.lastIndexOf('/') + 1),
            location: this.calendarNode.querySelector('.second-calendar-card').dataset.userLocation,
        };

        this.calendarNode.querySelector('.second-calendar-hours').innerHTML = '';

        let container = this.calendarNode.querySelector('.second-calendar-info-dynamic');

        let date = DateTime.fromFormat(
            day,
            "yyyy-MM-dd"
        ).setLocale('pl');

        let dayName = 'Jutro';

        if ((date - DateTime.now()) / 3600000 >= 24) {
            dayName = date.toFormat('cccc');
        }

        this.calendarNode.querySelector('.second-calendar-header-title-dynamic-text').innerHTML = dayName;

        for (let hr = 0; hr < MAX_USER_SLOTS; hr++) {

            const hour = slots[hr] || null;

            let timeDiv = container.querySelector('.second-calendar-hours-item-template').content
                .querySelector('.second-calendar-hours-item').cloneNode(true);

            timeDiv.style.width = "25%";
            if (MAX_USER_SLOTS / 2 > hr) {
                timeDiv.classList.add('mb-2');
            }

            if (null !== hour) {
                let date = DateTime.fromFormat(
                    day + ' ' + hour,
                    "yyyy-MM-dd HH:mm"
                ).setLocale('pl').setZone('Europe/Warsaw');
                let linkDate = date.toFormat('yyyy-LL-dd+HH:mm:\'00\'');
                timeDiv.title = "Zarezerwuj wizytę na godzinę " + hour;
                timeDiv.dataset.time = hour;
                timeDiv.href = '/umow-wizyte/' + userData.slug + '?serviceId=' + this.serviceId
                    + '&date=' + linkDate + ':00&ep=vuqsg1';
            } else {
                timeDiv.classList.add('invisible');
            }

            if (0 === hr) {
                timeDiv.classList.add('active');
                this.calendarNode.querySelector('.second-calendar-more-book').href = timeDiv.href;
            }

            timeDiv.innerHTML = `<span class="py-2">${hour || "NO"}</span>`;

            if (null !== hour) {
                timeDiv.addEventListener('click', () => {
                    this.calendarNode.querySelectorAll('.second-calendar-hours-item.active')
                        .forEach(el => el.classList.remove('active'));
                    this.calendarNode.querySelector('.second-calendar-more-book').href = timeDiv.href;
                    timeDiv.classList.add('active');
                });
            }

            container.querySelector('.second-calendar-hours').appendChild(timeDiv);
        }

        this.calendarNode.querySelector('.second-calendar-more-profile').classList.remove('disabled');
        this.calendarNode.querySelector('.second-calendar-info').classList.remove('second-calendar-loading');
        this.calendarNode.querySelector('.loading-ring').style.display = "none";
    };
}

window.addEventListener('DOMContentLoaded', () => {
    for (let calendarNode of document.querySelectorAll('.second-calendar-box')) {
        let calendar = new SecondCalendar(calendarNode);
        calendar.loadCalendar();
    }
});
